import { Paper, type PaperProps } from "@mui/material";
import { type ForwardedRef, forwardRef } from "react";

import { getSafeAreaPaddings } from "../../../ui-theme";
import { mergeSxProps } from "../../lib/mergeSxProps";

export type PageHeaderWrapperProps = PaperProps;

export function PageHeaderWrapperBase(
  props: PageHeaderWrapperProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  const { sx, variant = "primary", component = "header", ...restProps } = props;

  return (
    <Paper
      ref={ref}
      component={component}
      variant={variant}
      sx={mergeSxProps(
        // by default our designs do not have padding on the top of the header so we only need safe area inset
        // however, to make it look better on web or devices with no notch we add a small fallback top padding
        (theme) => ({
          ...getSafeAreaPaddings({ top: true, fallbackTop: theme.spacing(3) }),
          // This is to ensure that the header is always on top of underlying page and its shadow renders correctly on top of the page
          zIndex: 1,
        }),
        sx
      )}
      {...restProps}
    />
  );
}

export const PageHeaderWrapper = forwardRef(PageHeaderWrapperBase);
